import { PostMessageEvent } from '../types/message';

interface IPostMessageBody {
  eventName: PostMessageEvent;
  data?: object;
}

export const postMessage = (event: IPostMessageBody) => {
  if (window.parent !== window) {
    window.parent.postMessage(event, '*');
  }
};
